import { Password } from 'basis';
import {
  validVerbalPasswordCharsPattern,
  validVerbalPasswordLettersPattern,
  validVerbalPasswordNumbersPattern,
  validVerbalPasswordMinLength,
  validVerbalPasswordMaxLength,
} from '../_constants';

const validPasswordCharsRegex = new RegExp(validVerbalPasswordCharsPattern);
const validPasswordLettersRegex = new RegExp(validVerbalPasswordLettersPattern);
const validPasswordNumbersRegex = new RegExp(validVerbalPasswordNumbersPattern);

const VALIDATION_RULES = [
  {
    label: '6 - 15 characters',
    test: value => value.length >= validVerbalPasswordMinLength && value.length <= validVerbalPasswordMaxLength,
  },
  { label: '2 letters', test: value => value.length && validPasswordLettersRegex.test(value) },
  { label: 'No special characters', test: value => value.length && validPasswordCharsRegex.test(value) },
  { label: '2 numbers', test: value => value.length && validPasswordNumbersRegex.test(value) },
];

const fields = [
  {
    component: 'InfoBlock',
    name: 'passwordInfo',
    text:
      'This password will be used to confirm your identity when you call us for help with your account. Choose something easy for you to remember.',
  },
  {
    component: 'CustomComponent',
    children: Password,
    name: 'password',
    label: 'Password',
    testId: 'password',
    rules: VALIDATION_RULES,
  },
];

export const password = fields;
